export default __webpack_public_path__ + "static/media/greece.fbf7e7ae.png";